import React from 'react';
import styles from './InitiativesDashboard.module.scss';

import { useInitiativesDashboard } from './hooks/UseInitiativesDashboad';
import Loader from '../../../../Components/Loader/Loader';
import { WorkspaceView } from '../../../../Components/WorkspaceView/WorkspaceView';
import { SFSpinner } from 'sfui';
import { TinyWidgets } from '../../../../Components/TinyWidgets/TinyWidgets';
import { NoInitiatives } from './NoInitiatives/NoInitiatives';
import { InitiativesDashboardHeader } from './InitiativesDashboardHeader/InitiativesDashboardHeader';
import { InitiativesList } from './InitiativesList/InitiativesList';

export interface InitiativesDashboardProps {}

export const InitiativesDashboard = (
  props: InitiativesDashboardProps
): React.ReactElement<InitiativesDashboardProps> => {
  const {
    isLoading,
    isFetchingMoreInitiatives,
    initiatives,
    totals,
    tinyWidgetsTotals,
    onScrollBottom,
    refScrollable
  } = useInitiativesDashboard({});

  const hasInitiatives: boolean = initiatives.length > 0;

  return (
    <div className={styles.initiativesDashboard}>
      {isLoading && <Loader />}
      {!isLoading && !hasInitiatives && <NoInitiatives />}

      {!isLoading && hasInitiatives && (
        <>
          <WorkspaceView
            onScrollBottom={onScrollBottom}
            ref={refScrollable}
            header={<InitiativesDashboardHeader />}
          >
            <div className={styles.content}>
              {totals && <TinyWidgets totals={tinyWidgetsTotals} />}

              <InitiativesList initiatives={initiatives} />

              {isFetchingMoreInitiatives && (
                <div className={styles.moreInitiativesSpinner}>
                  <SFSpinner size={40} />
                </div>
              )}
            </div>
          </WorkspaceView>
        </>
      )}
    </div>
  );
};
